import { render, staticRenderFns } from "./PaymentsManage.vue?vue&type=template&id=650c8aab&scoped=true"
import script from "./PaymentsManage.vue?vue&type=script&lang=js"
export * from "./PaymentsManage.vue?vue&type=script&lang=js"
import style0 from "./PaymentsManage.vue?vue&type=style&index=0&id=650c8aab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c8aab",
  null
  
)

export default component.exports